import { OptionsManager, __getPropertyName } from "./OptionsManager.js";
import { useResize } from "../../services/index.js";
import { isDev } from "../../utils/index.js";
function __getResponsiveName(that, name) {
  const { breakpoint } = useResize().props();
  if (!breakpoint) {
    return name;
  }
  let responsiveName = name;
  const propertyName = __getPropertyName(name);
  const regex = new RegExp(`${propertyName}:(.+)$`);
  for (const optionName of Object.keys(that.__element.dataset)) {
    if (regex.test(optionName)) {
      const [, breakpoints] = optionName.match(regex);
      const isInBreakpoint = breakpoints.split(":").includes(breakpoint);
      if (isInBreakpoint) {
        responsiveName = optionName.replace(/^option/, "");
      }
    }
  }
  return responsiveName;
}
class ResponsiveOptionsManager extends OptionsManager {
  /**
   * Get an option value.
   *
   * @param   {string} name The option name.
   * @param   {ResponsiveOptionObject} config The option configuration.
   * @returns {any}
   */
  get(name, config) {
    if (!config.responsive) {
      return super.get(name, config);
    }
    return super.get(__getResponsiveName(this, name), config);
  }
  /**
   * Set an option value.
   *
   * @param {string} name The option name.
   * @param {any} value The new value.
   * @param {ResponsiveOptionObject} config The option configuration.
   */
  set(name, value, config) {
    if (!config.responsive) {
      super.set(name, value, config);
      return;
    }
    if (isDev) {
      console.warn(`[${this.__config.name}]`, "Responsive options are read-only.");
    }
  }
}
export {
  ResponsiveOptionsManager
};
//# sourceMappingURL=ResponsiveOptionsManager.js.map
